import styled from 'styled-components';
import {Input} from 'antd';

const StyledSearch = styled(Input)`
`;

export {
  StyledSearch
};
